import dayjs from "dayjs"
import { useEffect } from "react"
import { useAuthContext } from "src/contexts/AuthContext"
import { UserLocalStorageKey } from "src/types"

interface Props {
  setClearedAt: (v: string) => void;
}

export function LocalStorageHandler(props: Props) {
  const { setClearedAt } = props
  const { isAuthenticated } = useAuthContext()

  // clear user specific keys when logged out
  useEffect(
    () => {
      if (!isAuthenticated) {
        // all user specific async storage keys
        const userSpecificKeys = Object.values(UserLocalStorageKey)

        // remove values for all user specific async storage key
        userSpecificKeys.forEach((key) => localStorage.removeItem(key))

        setClearedAt(dayjs().toISOString())
      }
    },
    [
      isAuthenticated,
      setClearedAt,
    ],
  )

  return null
}
